function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from '@shared/components/spzaComponent';
import { Icon, TooltipHost } from '@fluentui/react';
import { getUTCDateString } from '@shared/utils/futurePricesUtils';
import { uniqueId } from 'lodash-es';
import classNames from 'classnames';
import { Text } from '@fluentui/react/lib/Text';
class FuturePriceTooltip extends SpzaComponent {
    renderImpl() {
        const iconId = 'futurePriceTooltipIcon' + uniqueId();
        const { className = '' } = this.props.futurePrice;
        const futurePriceTooltipClass = classNames('futurePrice', className);
        const textClass = classNames('futurePriceLabel', className);
        return /*#__PURE__*/ _jsx("div", {
            className: futurePriceTooltipClass,
            children: /*#__PURE__*/ _jsx(TooltipHost, {
                tooltipProps: this.tooltipProps,
                id: 'future-price-tooltip',
                calloutProps: {
                    target: `#${iconId}`,
                    gapSpace: 5
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    className: 'futurePriceTooltip',
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            "aria-describedby": 'future-price-tooltip',
                            iconName: "Info",
                            className: "futurePriceIcon",
                            id: iconId
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            className: textClass,
                            children: this.context.loc('FuturePrices_upcomingPriceChange', 'Upcoming price change')
                        })
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0), _define_property(this, "tooltipContent", ()=>{
            const { startDate, price, priceComponent, className = '' } = this.props.futurePrice;
            const startDateText = getUTCDateString(startDate, this.context);
            const futurePriceTooltipClass = classNames('futurePriceTooltipContent', className);
            return /*#__PURE__*/ _jsxs("div", {
                className: futurePriceTooltipClass,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: this.context.locParams('FuturePrices_message', [
                            startDateText
                        ])
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "price",
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: price
                        }
                    }),
                    priceComponent
                ]
            });
        }), _define_property(this, "tooltipProps", {
            onRenderContent: this.tooltipContent
        });
    }
}
export { FuturePriceTooltip as default };
FuturePriceTooltip.contextTypes = {
    renderErrorModal: PropTypes.func,
    locParams: PropTypes.func,
    loc: PropTypes.func,
    locDateString: PropTypes.func
};
